import React, { Fragment } from "react";
import { Button } from "@athena/forge";
interface FooterLink {
  text: string;
  href?: string;
  externalLink?: string;
}
interface FooterButton {
  button: React.JSX.Element;
  id: string;
}

export interface FooterPropsType {
  footerLinks?: FooterLink[];
  footerButtons?: FooterButton[];
}

const Footer = ({
  footerLinks,
  footerButtons,
}: FooterPropsType): React.JSX.Element => {
  return (
    <>
      <div className="okta-form-divider form-divider fe_u_margin--bottom-medium fe_u_margin--top-medium"></div>
      {!!footerButtons?.length &&
        footerButtons.map((footerButton, index) => (
          <div key={`${footerButton.id}-${index}`}>
            <Fragment key={`${footerButton.id}`}>
              {footerButton.button}
            </Fragment>
          </div>
        ))}
      <div className="fe_u_margin--top-medium"></div>
      {!!footerLinks?.length &&
        footerLinks.map((footerLink, index) => (
          <Fragment key={`${footerLink.text}-${index}`}>
            <Button
              className="fe_u_margin--right-medium"
              text={footerLink.text}
              variant="tertiary"
              size="large"
              fullWidth={false}
              onClick={() => {
                if (footerLink.externalLink) {
                  window.open(footerLink.externalLink, "_blank");
                } else if (footerLink.href) {
                  window.location.href = footerLink.href;
                }
              }}
            />
          </Fragment>
        ))}
    </>
  );
};

export default Footer;
